import { useEffect, useState } from "react";
import axios from "../../api/axios";
import "../../styles/theme-dark.css";

export default function ConfigInformeInstalacion({
  instalacionId,
  onGenerado,
  onCancel
}) {

  const [bloquesConItems, setBloquesConItems] = useState([]);
  const [seleccion, setSeleccion] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        console.log("📍 Intentando cargar bloques desde /api/bloques...");
        
        // CARGAR DESDE NUESTRA NUEVA RUTA /api/bloques
        const response = await fetch('/api/bloques');
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const data = await response.json();
        console.log("✅ Datos de /api/bloques:", data);
        
        // La respuesta viene como { ok: true, blocks: [...] }
        const bloques = data.blocks || data || [];
        
        console.log("🔢 Bloques encontrados:", bloques.length);
        
        if (bloques.length > 0) {
          setBloquesConItems(bloques);
          
          // Inicializar TODO seleccionado por defecto
          const inicial = {};
          bloques.forEach((bloque) => {
            if (bloque.items && Array.isArray(bloque.items) && bloque.items.length > 0) {
              inicial[bloque.id] = bloque.items.map((item) => item.id);
            }
          });
          console.log("✅ Selección inicial:", inicial);
          setSeleccion(inicial);
        } else {
          console.warn("⚠️ No se encontraron bloques");
          // Datos de prueba para desarrollo
          const datosPrueba = [
            {
              id: 1,
              nombre: "INSTALACIÓN",
              items: [
                { id: 1, texto: "Verificar conexión eléctrica" },
                { id: 2, texto: "Comprobar nivelación" },
                { id: 3, texto: "Revisar presión neumáticos" }
              ]
            },
            {
              id: 2,
              nombre: "SEGURIDAD",
              items: [
                { id: 4, texto: "Protecciones instaladas" },
                { id: 5, texto: "Señalización correcta" }
              ]
            },
            {
              id: 3,
              nombre: "PRUEBAS",
              items: [
                { id: 6, texto: "Funcionamiento motores" },
                { id: 7, texto: "Prueba sensores" }
              ]
            }
          ];
          setBloquesConItems(datosPrueba);
          
          const inicialPrueba = {};
          datosPrueba.forEach((bloque) => {
            inicialPrueba[bloque.id] = bloque.items.map((item) => item.id);
          });
          setSeleccion(inicialPrueba);
        }
        
      } catch (error) {
        console.error("❌ Error cargando bloques:", error);
        
        // Datos de emergencia si falla la carga
        const datosEmergencia = [
          {
            id: 1,
            nombre: "INSTALACIÓN",
            items: [
              { id: 1, texto: "Bloque creado desde checklist" },
              { id: 2, texto: "Agrega más items en configuración" }
            ]
          }
        ];
        setBloquesConItems(datosEmergencia);
        
        const inicialEmergencia = {};
        datosEmergencia.forEach((bloque) => {
          inicialEmergencia[bloque.id] = bloque.items.map((item) => item.id);
        });
        setSeleccion(inicialEmergencia);
        
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  function toggleBloque(bloque) {
    setSeleccion((prev) => {
      if (prev[bloque.id]) {
        const copy = { ...prev };
        delete copy[bloque.id];
        return copy;
      }
      return {
        ...prev,
        [bloque.id]: bloque.items.map((i) => i.id),
      };
    });
  }

  function toggleItem(bloqueId, itemId) {
    setSeleccion((prev) => {
      const items = prev[bloqueId] || [];
      if (items.includes(itemId)) {
        const nuevos = items.filter((id) => id !== itemId);
        if (!nuevos.length) {
          const copy = { ...prev };
          delete copy[bloqueId];
          return copy;
        }
        return { ...prev, [bloqueId]: nuevos };
      }
      return { ...prev, [bloqueId]: [...items, itemId] };
    });
  }

  async function generar() {
    try {
      setSaving(true);
      
      // Preparar los bloques en el formato que espera el backend
      const bloquesParaEnviar = Object.keys(seleccion).map(bloqueId => ({
        bloqueId: parseInt(bloqueId),
        todos: true // Seleccionamos todos los items del bloque
      }));
      
    console.log("📤 Enviando al backend:", {
  bloques: bloquesParaEnviar
});


      // Usar fetch en lugar de axios para consistencia
      const response = await fetch(
  `/api/checklists/instalacion/${instalacionId}/generar`,
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      bloques: bloquesParaEnviar
    })
  }
);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error generando checklist');
      }
      
      const result = await response.json();
      console.log("✅ Checklist generado:", result);
      
      if (onGenerado) {
  onGenerado(result);
}

      
    } catch (error) {
      console.error("❌ Error generando informe:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="page-dark" style={{ padding: 20, color: "#fff" }}>
        Cargando bloques de checklist...
      </div>
    );
  }

  return (
    <div className="page-dark" style={{ 
      padding: "16px",
      minHeight: "100vh",
      backgroundColor: "#0f172a"
    }}>
      {/* TÍTULO - TEXTO PEQUEÑO */}
      <div style={{ 
        fontSize: "16px", 
        fontWeight: 600, 
        marginBottom: "16px",
        color: "#fff"
      }}>
        Configurar informe de instalación
      </div>

      {/* CONTENEDOR PRINCIPAL */}
      <div style={{
        height: "calc(100vh - 160px)",
        overflowY: "auto",
        marginBottom: "16px",
        paddingRight: "4px"
      }}>
        {/* GRID DE 3 COLUMNAS */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "10px",
          alignItems: "start"
        }}>
          {bloquesConItems.map((bloque) => (
            <div
              key={bloque.id}
              style={{
                padding: "10px",
                borderRadius: "6px",
                background: "rgba(255, 255, 255, 0.04)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                minHeight: "100px"
              }}
            >
              {/* TÍTULO DEL BLOQUE - TEXTO PEQUEÑO */}
              <div style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "6px"
              }}>
                <input
                  type="checkbox"
                  style={{
                    width: "14px",
                    height: "14px",
                    marginRight: "6px",
                    cursor: "pointer"
                  }}
                  checked={!!seleccion[bloque.id]}
                  onChange={() => toggleBloque(bloque)}
                />
                <span style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#fff",
                  textTransform: "uppercase"
                }}>
                  {bloque.nombre}
                </span>
              </div>

              {/* ITEMS - TEXTO MUY PEQUEÑO - SIN SCROLL */}
              <div style={{ 
                height: "auto",
                minHeight: "40px",
                overflowY: "visible",
                paddingRight: "2px"
              }}>
                {bloque.items && bloque.items.map((item) => (
                  <div 
                    key={item.id} 
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "2px",
                      marginLeft: "20px",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{
                        width: "12px",
                        height: "12px",
                        marginRight: "4px",
                        cursor: "pointer"
                      }}
                      checked={Boolean(seleccion[bloque.id]?.includes(item.id))}

                      onChange={() => toggleItem(bloque.id, item.id)}
                    />
                    <span style={{
                      fontSize: "11px",
                      color: seleccion[bloque.id]?.includes(item.id) 
                        ? "#10b981"
                        : "rgba(255, 255, 255, 0.7)",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px"
                    }}>
                      {seleccion[bloque.id]?.includes(item.id) && (
                        <span style={{ fontSize: "10px" }}>✅</span>
                      )}
                      {item.texto || `Item ${item.id}`}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* BOTONES - TEXTO PEQUEÑO */}
      <div style={{ 
        display: "flex", 
        gap: "10px",
        paddingTop: "12px",
        borderTop: "1px solid rgba(255, 255, 255, 0.1)"
      }}>
        <button
          style={{
            padding: "6px 16px",
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            borderRadius: "4px",
            color: "#fff",
            fontSize: "12px",
            cursor: "pointer"
          }}
          onClick={onCancel}
        >
          Cancelar
        </button>
        <button
          style={{
            padding: "6px 16px",
            backgroundColor: saving ? "rgba(59, 130, 246, 0.5)" : "#3b82f6",
            border: "1px solid rgba(59, 130, 246, 0.5)",
            borderRadius: "4px",
            color: "#fff",
            fontSize: "12px",
            cursor: saving ? "not-allowed" : "pointer"
          }}
          disabled={saving || bloquesConItems.length === 0}
          onClick={generar}
        >
          {saving ? "Generando..." : "Generar instalación"}
        </button>
      </div>

      {/* INFO DEBUG PEQUEÑA */}
      <div style={{ 
        fontSize: "11px",
        color: "rgba(255, 255, 255, 0.5)",
        marginTop: "8px",
        textAlign: "center"
      }}>
        {bloquesConItems.length} bloques cargados • 
        {Object.keys(seleccion).length} seleccionados
      </div>
    </div>
  );
}